export const SEPA_PAYMENT_INTENT: string = "SEPA_PAYMENT_INTENT";
